import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { fetchApi } from '../../utils/methods';
import { toast } from 'react-toastify';
import { CheckHealth } from '../../redux/constants/apiConstants';
import history from '../../utils/history';
import Waiting from '../Waiting';

const Wrapper = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #0f2027, #203a43, #2c5364);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: #fff;
`;

const Card = styled.div`
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 48px 40px;
  max-width: 520px;
  width: 100%;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.35);
`;

const Icon = styled.div`
  font-size: 64px;
  margin-bottom: 24px;
`;

const Title = styled.h1`
  font-size: 28px;
  margin-bottom: 16px;
  font-weight: 600;
`;

const Description = styled.p`
  font-size: 16px;
  opacity: 0.9;
  line-height: 1.6;
  margin-bottom: 32px;
`;

const Divider = styled.div`
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
  margin: 24px 0;
`;

const FooterText = styled.p`
  font-size: 14px;
  opacity: 0.7;
`;

const MaintenancePage = () => {
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(()=>{
    getServerHealth();
  },[]);

  const getServerHealth = async () => {
    setLoading(true);
    try {
      const res = await fetchApi(CheckHealth, "GET");
      if (res?.status === "success") {
        history.push("/portal");
      } else {
        setErrorMessage()
      }
    } catch (error) {
      toast.error(error);
    }finally{
      setLoading(false);
    }
  }

  
  return (
    <>{loading ? <Waiting/> : 
      <Wrapper>
        <Card>
          <Icon>🛠️</Icon>
          <Title>{errorMessage || "We’re Under Maintenance"}</Title>
          <Description>
            Our website is currently undergoing scheduled maintenance.
            We’re working hard to improve your experience and will be back shortly.
          </Description>
  
          <Divider />
  
          <FooterText>
            Thanks for your patience 💙 <br />
            Please check back soon.
          </FooterText>
        </Card>
      </Wrapper>}
    </>
  );
};

export default MaintenancePage;
